module.exports = __webpack_public_path__ + "ru.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ru.svg
// module id = 1038
// module chunks = 0